/**
 * @author      nick.coffey@zumper.com (Nick Coffey)
 * @copyright   Copyright (c) 2020, Zumper
 * @description AppStoreLink component
 */

import {
  BetaFeature,
  ZUMPER_APPSFLYER_IOS_PID,
  isBetaFeatureEnabled,
  useConstructAppsFlyerLink,
} from '@zcode/nr-utils'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useLocation } from 'react-router-dom'
import appStore from '../../img/badges/app_store_badge.svg'
import css from './AppStoreLink.module.scss'

interface Props {
  className?: string
  onClick?: React.MouseEventHandler
  origin: 'homepage' | 'homepage_zr' | 'footer'
}

export const AppStoreLink = ({ className, onClick, origin }: Props) => {
  const location = useLocation()
  const isAppsFlyer = isBetaFeatureEnabled(location, BetaFeature.APPS_FLYER)
  const appsFlyerLink = useConstructAppsFlyerLink(origin, ZUMPER_APPSFLYER_IOS_PID)

  return (
    <a
      aria-label="download the Zumper app in the apple store"
      href={isAppsFlyer ? appsFlyerLink : 'https://dt5a9.app.goo.gl/AaXO'}
      onClick={onClick}
      rel="noopener noreferrer"
      role="button"
      target="_blank"
      title="Apple App Store"
    >
      <img
        alt=""
        className={classNames(css.appStoreLink, className)}
        height={40}
        loading="lazy"
        src={appStore}
        width={135}
      />
    </a>
  )
}

AppStoreLink.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}
